module.exports = __webpack_public_path__ + "img/card-ap-month.828bc849.jpg";